const Organization = () =>
  import(
    /* webpackChunkName: "organization" */ "@/app/admin/organization/setting/organization"
  );
const Staff = () =>
  import(
    /* webpackChunkName: "organization" */ "@/app/admin/organization/staff/staff"
  );

export default [
  {
    path: "organization",
    name: "organization",
    redirect: "organization/setting"
  },
  {
    path: "organization/setting",
    name: "setting",
    component: Organization,
    meta: {
      title: "组织架构管理",
      key: "organization",
      permission: "office_setting.office_manager.btn_look_up"
    }
  },
  {
    path: "organization/staff",
    name: "staff",
    component: Staff,
    meta: {
      title: "员工管理",
      key: "staff",
      permission: "office_setting.staff_manager.btn_look_up"
    }
  }
];
